import React, { useState } from 'react';
import { Button, Popover, Paper } from '@mui/material';
import { ArrowDownSVG } from '../../assets/img/arrow-down';
import { ButtonResetStyle } from 'components/Button/Button';

export type SelectButtonItemProps = {
  label: string;
  handler?: () => (Promise<void>) | void;
  desc?: string;
  icon?: React.ReactNode;
}

const SelectButton = ({ options, label, busy }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);
    return Promise.resolve();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionSelect = async (handler) => {
    await handler();
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleClick}
        variant="contained"
        color="primary"
        disabled={busy}
        endIcon={<ArrowDownSVG fill='#fff' />}
        style={{ minWidth: 100 }}
      >
        {label}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Paper style={{ padding: '8px' }}>
          {options.map((option: SelectButtonItemProps, idx: number) => (
            <ButtonResetStyle key={idx} extStyled={{
              width: '100%',
              gap: '12px',

              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }} onClick={() => handleOptionSelect(option.handler)}>
              {option.icon}
              <div>
                <p className='m-0 font-weight-bold' style={{ fontSize: '14px' }}>{option.label}</p>
                <p className='m-0' style={{
                  // elipsis if too long
                  // whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '280px',
                  fontSize: '12px',
                  color: '#666'
                }}>
                  {option.desc}
                </p>
              </div>
            </ButtonResetStyle>
          ))}
        </Paper>
      </Popover>
    </>
  );
};

export default SelectButton;
